import moment from 'moment-timezone';
import { isEmpty } from '@ember/utils';
import { DateTime, YearMonthDay } from '@square/dashboard-protos/models/squareup/common/time';
import { getBrowserTimeZone } from '@dashboard/junk-drawer/utils/time';

/**
 * CARGO CULTED FROM `@dashboard/junk-drawer`!!
 *
 * Converts a DateTime with timezone data into a timezone-aware moment object.
 *
 * @param {DateTime} dateTime
 * @returns {moment}
 */
export function momentFromDateTimeWithZone(dateTime) {
  if (isEmpty(dateTime.tzName)) {
    throw new Error('DateTime proto must have a tzName');
  }
  const validTzName = dateTime.tzName.find(name => moment().tz(name).tz());
  if (!validTzName) {
    throw new Error(`DateTime proto does not have a known timezone; given time zones: ${JSON.stringify(dateTime.tzName)}`);
  }
  return moment.tz(usecToMs(dateTime.instantUsec), validTzName);
}

/**
 * CARGO CULTED FROM `@dashboard/junk-drawer`!!
 *
 * Converts microseconds to milliseconds. Javascript and moment only support milliseconds
 * @param {number} usec
 * @returns {number}
 */
export function usecToMs(usec) {
  return usec / 1000;
}
export function msToUsec(ms) {
  return ms * 1000;
}
export function getCurrentDateTime() {
  return DateTime.create({
    instantUsec: convertDateToUsec(),
    tzName: [getBrowserTimeZone()]
  });
}
export function convertDateToUsec(date = new Date()) {
  return msToUsec(date.getTime());
}
export function convertDateToYearMonthDay(date) {
  return YearMonthDay.create({
    year: date.getFullYear(),
    monthOfYear: date.getMonth() + 1,
    // offset by 1 since moment uses 0-11 and YearMonthDay expects 1-12
    dayOfMonth: date.getDate()
  });
}
export function convertYearMonthDayToDate(yearMonthDate) {
  const {
    dayOfMonth,
    monthOfYear,
    year
  } = yearMonthDate;
  return new Date(year, monthOfYear - 1, dayOfMonth);
}